import { HttpParams } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Tc } from '../../../core/_infrastructure/types/common';
import {
    FilterSearchingTDeclaracionSuplementariaViewModel,
    TDeclaracionSuplementariaViewModel,
    DeclaracionSuplementariaItemResultsViewModel,
} from './declaracionsuplementaria.types';

@Injectable()
export class DeclaracionSuplementariaService {
    declaracionSuplementariaEndpoint = this.baseUrl + 'api/mantenimiento/declaracionsuplementaria/';
    private lastSearch?: FilterSearchingTDeclaracionSuplementariaViewModel;

    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {}

    private convertModelToHttpParms(payload: FilterSearchingTDeclaracionSuplementariaViewModel): HttpParams {
        let params = new HttpParams();
        let k: keyof FilterSearchingTDeclaracionSuplementariaViewModel;

        for (k in payload) {
            let v;
            let valor = payload[k];
            if (k == 'Activa' && valor == 0) {
                v = 0;
            } else {
                v = payload[k] || '';
            }

            params = params.append(k, v);
        }

        return params;
    }

    getDeclaracionesSuplementarias(payload: FilterSearchingTDeclaracionSuplementariaViewModel): Observable<DeclaracionSuplementariaItemResultsViewModel> {
        this.lastSearch = payload; // Keep for future search
        const params = this.convertModelToHttpParms(payload);
        return this.getDeclaracionesSuplementariasPagedByFilter(params);
    }

    getDeclaracionesSuplementariasPagedByFilter(params: HttpParams): Observable<DeclaracionSuplementariaItemResultsViewModel> {
        return this.http.get<DeclaracionSuplementariaItemResultsViewModel>(this.declaracionSuplementariaEndpoint + 'pagedbyfilter/', { params: params });
    }

    getDeclaracionSuplementaria(id: number): Observable<TDeclaracionSuplementariaViewModel> {
        return this.http.get<TDeclaracionSuplementariaViewModel>(this.declaracionSuplementariaEndpoint + id);
    }

    getTipoTextoDeclaracionSuplementaria(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.declaracionSuplementariaEndpoint + 'tipotexto');
    }

    saveDeclaracionSuplementaria(declaracionSuplementaria: TDeclaracionSuplementariaViewModel): Observable<any> {
        if (declaracionSuplementaria?.Id) {
            return this.editDeclaracionSuplementaria(declaracionSuplementaria);
        }
        return this.createDeclaracionSuplementaria(declaracionSuplementaria);
    }

    createDeclaracionSuplementaria(declaracionSuplementaria: TDeclaracionSuplementariaViewModel): Observable<any> {
        return this.http.post<TDeclaracionSuplementariaViewModel>(this.declaracionSuplementariaEndpoint, declaracionSuplementaria);
    }

    editDeclaracionSuplementaria(declaracionSuplementaria: TDeclaracionSuplementariaViewModel): Observable<any> {
        return this.http.put<TDeclaracionSuplementariaViewModel>(this.declaracionSuplementariaEndpoint, declaracionSuplementaria);
    }

    getLastSearch(): FilterSearchingTDeclaracionSuplementariaViewModel | undefined {
        return this.lastSearch;
    }

    clearLastSearch(): void {
        this.lastSearch = undefined;
    }

    getCloneDeclaracionSuplementaria(id: number): Observable<any> {
        return this.http.get<TDeclaracionSuplementariaViewModel>(this.declaracionSuplementariaEndpoint + 'clonedeclaracionsuplementaria/' + id);
    }
}
